import * as React from "react";
import { JSX } from "react/jsx-runtime";
const ComfortableIcon = ({
  color = "white",
  ...props
}: JSX.IntrinsicAttributes &
  React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    width={15}
    height={14}
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.5 7C1.5 10.3137 4.18629 13 7.5 13C10.8137 13 13.5 10.3137 13.5 7C13.5 3.68629 10.8137 1 7.5 1C5.96329 1 4.56151 1.57771 3.5 2.52779M2.83333 1V3C2.83333 3.36819 3.13181 3.66667 3.5 3.66667H5.5M9.5 5.66667L7.06904 8.09763C6.93886 8.22781 6.72781 8.22781 6.59763 8.09763L5.5 7"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default ComfortableIcon;
